<template>
    <div class="dropdown" role="navigation">
        <div class="trigger">
            <slot name="trigger"/>
        </div>
        <div class="content">
            <slot/>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Dropdown',
};
</script>
<style lang="scss" scoped>
.dropdown {
    position: relative;

    > .trigger {
        cursor: pointer;
    }

    > .content {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        z-index: 1;
    }

    &:hover, &:focus-within {
        .content {
            display: block;
        }
    }
}
</style>
